type Category = "ALUMINI" | "STUDENT";

interface AlumniOrStudent {
  name: string;
  image: string;
  category: Category;
  position?: string;
  description?: string;
  batch?: string;
}

export const ALUMNI_AND_STUDENTS: AlumniOrStudent[] = [
  {
    name: "Bishwas Thapa Magar",
    image: "/img/alumni/Bishwas_PCPS.jpg",
    category: "ALUMINI",
    position:
      "Business Architecture Analyst -NSAA Securities Australia",
    batch: "Batch of 2019",
    description: `PCPS College has been the strongest foundation for my career. The internship opportunities I received from the very first year helped me gain industry-ready knowledge, which contributed significantly to my success even in a foreign country.`,
  },
  {
    name: "Sijan Tandukar",
    description: `I feel proud to be a part of PCPS College, where the learning pedagogy LTW system is not only practical but also perfectly aligned with today’s industry demands. The hands-on approach and real-world focus have truly prepared me for professional success.`,
    image: "/img/alumni/Sijan_Tandukar.png",
    category: "ALUMINI",
    position: "Mid level QA Engineer - Varosa Technology",
    batch: "Batch of 2024"
  },
  /* {
    name: "Aryan Tibrewal",
    description: `The constant support, flexible learning environment, and placement opportunities allowed me to gain practical knowledge in IT, which has been instrumental in helping me run business operations smoothly and efficiently.`,
    image: "/img/alumni/Sijan_Tandukar.png",
    category: "ALUMNI",
    position: "Chief Operating Officer, Everest Pharmaceutical , Batch of 2024",
  }, */
  {
    name: "Bashu Shree Rayamajhi",
    description: `From my very first semester at PCPS College, I was encouraged to think critically and present with confidence. I was even given the opportunity to present directly to professors in the UK. This experience not only shaped my communication skills but also gave me the creative confidence I carry into my professional roles today.`,
    image: "/img/alumni/BashuSree.jpg",
    category: "ALUMINI",
    position: "Marketing Assosiate at Mero job",
    batch: "Batch of 2024"
  },
  {
    name: "Yaman Maharjan",
    description: `At PCPS College, I was able to gain hands-on practical knowledge that went beyond the classroom. The supportive environment allowed me to take on freelancing projects, explore my creative interests, and still manage my academics effectively. This balance prepared me for real-world challenges with both confidence and skills`,
    image: "/img/alumni/Yaman Maharjan.jpg",
    category: "ALUMINI",
    position: "Software Developer at Fintech Nepal",
    batch: "Batch of 2024"
  },
  {
    name: "Shishab Shrestha",
    description: `PCPS College gave me the rare opportunity to run my own business within the college premises. This experience taught me more than theory ever could from managing operations and dealing with customers to building confidence as an entrepreneur. The trust and support I received from the college helped me turn my ideas into action and prepared me to dream bigger.`,
    image: "/img/alumni/sishub.jpg",
    category: "STUDENT",
    position: "CEO of lingo and Landscape",
    batch: "L5 BSc S.E"
  },
  {
    name: "Niharika Shakya",
    description: `One of the biggest strengths of PCPS College is that it is run by IT professionals. I had the chance to learn directly from mentors with real industry experience, which gave me practical insights, live guidance, and the confidence to step into my role as an Associate Software Engineer.`,
    image: "/img/alumni/Niharika.jpg",
    category: "STUDENT",
    position: "Associate Software Engineer at Amnil Technologies",
    batch: "L5 BSc S.E"
  },
];
